import { useState } from 'react';
import { Options } from '../types';

const useSearch = (options: Options) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearchValueChange = (searchValue: string) => {
    setSearchValue(searchValue);
  };

  const searchValueEscape = (searchValue: string) => {
    const specialCharacter = ['\\', '$', '(', ')', '*', '+', '.', '[', '?', '^', '{', '|'];
    specialCharacter.forEach((str) => {
      const reg = new RegExp(`\\${str}`, 'gim');
      searchValue = searchValue?.replace?.(reg, `\\${str}`);
    });

    return searchValue;
  };

  const replaceMatch = (text, _searchValue = searchValue) => {
    _searchValue = searchValueEscape(_searchValue);
    const reg = new RegExp(`${_searchValue}`, 'gi');
    const setText = (text) => `<span style='color: #006EFF'>${text}</span>`;
    return text?.replace?.(reg, (matchText) => setText(matchText));
  };

  const buildHighLightData: () => Options = () => {
    // 无 searchValue 展示全部
    if (!searchValue) return options;
    const renderOptions = options?.map((option) => {
      // const filterText = option?.text?.replace(reg, (matchText) => setText(matchText))
      const filterText = replaceMatch(option?.text);

      // 过滤掉不包含 searchValue 的项
      if (option.text === filterText) return null;

      return {
        ...option,
        text: filterText,
      };
    });
    return renderOptions?.filter((item) => item !== null) as Options;
  };

  return {
    searchValue,
    setSearchValue,
    replaceMatch,
    buildHighLightData,
    handleSearchValueChange,
  };
};

export default useSearch;
